import { Component } from '@angular/core';
import { ConsentService } from './consent.service';

@Component({
  selector: 'lib-consent-banner',
  template: `
    <div class="consent-banner" role="dialog" aria-label="Cookie consent" *ngIf="consent.choice === null">
      <p>
        We use strictly necessary cookies to keep you signed in. With your permission we also use
        performance monitoring and embedded video, which may set additional cookies and send data to
        third parties. You can change your choice at any time.
      </p>
      <div class="consent-actions">
        <button type="button" (click)="consent.deny()">Necessary only</button>
        <button type="button" class="primary" (click)="consent.grant()">Accept all</button>
      </div>
    </div>
  `,
  styles: [`
    .consent-banner {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 10000;
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 1.5rem;
      background: #fff;
      border-top: 1px solid #e1dbdb;
      box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    }
    p { margin: 0; flex: 1 1 24rem; font-size: 0.875rem; }
    .consent-actions { display: flex; gap: 0.5rem; }
    button {
      padding: 0.5rem 1rem;
      border: 1px solid #555;
      border-radius: 4px;
      background: #fff;
      cursor: pointer;
    }
    button.primary { background: #222; color: #fff; }
  `]
})
export class ConsentBannerComponent {
  constructor(public consent: ConsentService) { }
}
